import { IconColumns3 } from "@tabler/icons-react";
import type { FC } from "react";
import { ButtonVariant } from "../Buttons/button.js";
import { IconButton } from "../Buttons/iconButton.js";
import { Size } from "../helpers/helpers.js";
import { SimpleTooltip } from "../tooltip/simpleTooltip.js";
import { TooltipTrigger } from "../tooltip/tooltipTrigger.js";

/**
 * Icon-button trigger used to open a "Display columns" multi-select menu
 * (pair it with {@link ../Menu/multiSelectMenuPopover} inside a
 * `MenuTrigger`). Renders as a secondary icon button with a "Display columns"
 * tooltip.
 */
export const DisplayColumnsMenuTrigger: FC = () => {
  return (
    <TooltipTrigger>
      <IconButton
        accessibleLabel="Display columns"
        icon={<IconColumns3 className="size-4 shrink-0 text-gray-700" />}
        size={Size.SMALL}
        variant={ButtonVariant.Secondary}
      />
      <SimpleTooltip>Display columns</SimpleTooltip>
    </TooltipTrigger>
  );
};
